"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createNavigationByIdEndpointRequest = void 0;
function createNavigationByIdEndpointRequest(navigationTreeId, parameters) {
    var _a;
    return {
        method: 'GET',
        endpoint: `navigation/trees/${navigationTreeId}`,
        params: Object.assign(Object.assign({}, (parameters.locale ? { locale: parameters.locale } : {})), (((_a = parameters === null || parameters === void 0 ? void 0 : parameters.with) === null || _a === void 0 ? void 0 : _a.category) ? { with: 'category' } : {})),
    };
}
exports.createNavigationByIdEndpointRequest = createNavigationByIdEndpointRequest;
